import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { Button, ButtonBar } from './UI';

const config = window.dodConfig;

const HeartsZeroPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-top: ${p => config.isLandscape ? 50 : 100}px;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${p => config.isLandscape ? 40 : 90}%;
	margin: 0 auto;
`

const BoxContent = styled.img`
	width: 90%;
	margin-top: 5%;
`

const CloseButton = styled.img`
	width: 12vw;
	position: absolute;
	top: 0;
	right: 0;
`

const ToSBody = styled.div`
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: column;
	padding-top: 15vw;
`

const ToSButton = styled.button`
	background-color: #ccc;
	color: black;
	padding: 3vw;
	flex: 0 0 3vw;
`

const ToSFrame = styled.iframe`
	flex-grow: 1;
`


export class ModalHeartsZero extends Component {

	state = {
		iframe: ""
	}

	continue(){
		window.manager.playAudio("poopPop");
		store.modal = '';
	}

	learn(){
		window.manager.playAudio("poopPop");
		store.modal = 'learn';
	}

	closeFaq() {
		window.manager.playAudio("poopPop");
		this.setState({iframe: ""});
	}

	render() {
		if(this.state.iframe){
			return(
				<ToSBody>
					<ToSButton opacity={1} onClick={() => {this.closeFaq()}}>Close</ToSButton>
					<ToSFrame title="terms" src={this.state.iframe}/>
				</ToSBody>
			);
		}
		return (
			<HeartsZeroPage>
				<Content>
					<CloseBox>
						<CloseButton src="/assets/btn_close.png" onClick={e => this.continue()}/>
						<BoxContent src={`/assets/languages/${store.settings.language}/no_more_extra_rolls.png`}/>
						<ButtonBar>
							<Button faq
								onClick={() => {
									window.manager.playAudio("poopPop");
									this.setState({iframe: "https://www.shakeitupdice.com/gamefaq.html"});
								}}
							/>
						</ButtonBar>
					</CloseBox>
				</Content>
			</HeartsZeroPage>
		)
	}
}
